import axios from "axios";
import { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;

export const AiMatchBox = ({ q, onChange, reload }) => {
  const [busy, setBusy] = useState(false);
  const m = q.ai_match;
  if (!m || m.confirmed || q.status !== "planned") return null;
  const confirm = async () => {
    setBusy(true);
    try { await axios.post(`${API}/queue/${q.id}/confirm-match`); toast.success("Produs confirmat"); await reload(); } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <div className="mx-4 mb-3 rounded-lg border border-sky-500/40 bg-sky-500/10 p-2" data-testid={`ai-match-${q.id}`}>
      <p className="mb-1.5 flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-sky-300"><Sparkles className="h-3 w-3" /> AI a recunoscut</p>
      <div className="flex items-center gap-2">
        {m.image ? <img src={m.image} alt="" className="h-12 w-12 shrink-0 rounded object-cover" data-testid={`ai-match-img-${q.id}`} />
          : <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded bg-zinc-800 text-[10px] text-zinc-400">general</div>}
        <p className="min-w-0 flex-1 text-xs text-zinc-100 line-clamp-2" data-testid={`ai-match-title-${q.id}`}>{m.title}</p>
        <button data-testid={`ai-match-confirm-${q.id}`} onClick={confirm} disabled={busy} className="inline-flex shrink-0 items-center gap-1 rounded-full bg-sky-400 px-3 py-1 text-xs font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Check className="h-3 w-3" />} Corect
        </button>
        <button data-testid={`ai-match-change-${q.id}`} onClick={onChange} disabled={busy} className="shrink-0 rounded-full border border-zinc-600 px-3 py-1 text-xs text-zinc-200 hover:border-amber-400">Alt produs</button>
      </div>
    </div>
  );
};
